export default __webpack_public_path__ + "static/media/map-alerts.debf606c.svg";